// Home.js
import React from "react";
import { Link } from "react-router-dom";
import "./App.css";

function Home() {
  return (
    <div className="home-container">
        <img
        src="https://i.ibb.co/HLfdrpYz/logo.png"
        alt="Pokot Logo"
        className="home-logo"
      />
      <p className="welcome-text">
        Türkiye'deki One Piece ve Pokemon TCG turnuvalarının sonuçlarını, kazanan kişileri görüp destelerini inceleyebileceğiniz platformumuza hoş geldiniz. Lütfen oyun seçin :)
      </p>
      <div className="nav-buttons">
        <Link to="/onepiece" className="nav-button">One Piece TCG</Link>
        <Link to="/pokemon" className="nav-button">Pokémon TCG</Link>
      </div>
    </div>
  );
}

export default Home;
